import { makeStyles } from 'tss-react/mui';
import { alpha, Theme } from '@mui/material';

export
  const useStyles = makeStyles()((theme: Theme) => ({
   // Root container styling
    root: { 
      marginRight: 20, marginLeft: 20,  marginTop: 20, fontSize: '1em !important', color: '#fff' },
    container: {
      border: 'none',
      "&.label.Mui-focused ": { color: 'white', }
    },
    table: {
      minWidth: 700,
      borderRadius: '5px',
      '& .MuiTableCell-root': {
        paddingTop: 0,
        paddingBottom: 0,
        minHeight: 28,
        fontSize: '1em',
      },
    },
    tC: {
      paddingLeft: 20, textAlign: 'left', fontSize: 16,
    },
    tCB: {
      paddingLeft: 20, textAlign: 'left', fontSize: 16, color: 'RED',
    },
    ba: { border: 'none', marginTop: 10 },
    bb: { color: '#2E2D2C' },
    tField: {
      paddingTop: 2,
      display: 'flex',
      backgroundColor: alpha('#fff', 0.4),
      '& label': { fontSize: 20, height: 45, lineHeight: .8, backgroundColor: '1px solid #4f4d4c', },
      height: 45,
      '& .MuiInput-underline:after': { height: 45, width: 0, fontSize: 20 },
      "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
        fontSize: 20,
        border: '1px solid #c4c4c4',
      },
      // (Note: space or no space after `&` matters. See SASS "parent selector".)
      '& .MuiOutlinedInput-root': {
        color: 'black',
        height: 47,
        fontSize: 20,
        // - The Input-root, inside the TextField-root
        '& fieldset': {
          border: '2px solid white',
          /* - The <fieldset> inside the Input-root */
        },
        '&:hover fieldset': {},
        '&.Mui-focused ': {
          backgroundColor: alpha('#fff', 0.8),
        },
      },
    },
  }),
  );
